import React, { Component } from 'react';
import { Modal, Alert, Card, Form, Col, Row, Button, Dropdown, ButtonGroup, ToggleButton, Popover, OverlayTrigger } from 'react-bootstrap'

class CustomerProfileModal extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    hideModal = () => {
        this.props.closeModal();
    }

    render() {
        return (
            <>
                <Modal.Header><h4>{this.props.model.accountName} Coding Profile</h4></Modal.Header>
                <Modal.Body>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Emr Vendor</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.emrVendor} />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Code in Software</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.codeInSoftware} />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Enter Severity Codes</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.enterSeverityCodes} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Severity Code Preferences</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.severityCodePreferences} />
                        </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Use Our Worksheets</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.useOurWorksheets} />
                        </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Message Line of Email</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.messageLineOfEmail} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Change Visit Status Location</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.changeVisitStatusLocation} />
                        </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Change 485 Status Location</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.change485StatusLocation} />
                        </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Enter Note Stating Review Complete</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.enterNoteStatingReviewComplete} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Validation Tool used</Form.Label>
                                <Form.Control plaintext readOnly defaultValue={this.props.model.validationToolUsed} />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label className="font-weight-bold">Code Verification Preference</Form.Label>
                            <Form.Control plaintext readOnly defaultValue={this.props.model.codeVerificationPreference} />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label className="font-weight-bold">Chart On Hold Documentation Method</Form.Label>
                            <Form.Control plaintext readOnly defaultValue={this.props.model.chartOnHoldDocumentationmethod} />
                        </Form.Group>

                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="font-weight-bold">Waiting on Agency Preference</Form.Label>
                            <Form.Control plaintext readOnly defaultValue={this.props.model.waitingOnAgencyPreference} />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label className="font-weight-bold">Homecare Queue</Form.Label>
                            <Form.Control plaintext readOnly defaultValue={this.props.model.homecareQueue} />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label className="font-weight-bold">Hospice Queue</Form.Label>
                            <Form.Control plaintext readOnly defaultValue={this.props.model.hospiceQueue} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="font-weight-bold">Return Review To</Form.Label><br />
                            {this.props.model.returnReviewTo !== undefined && this.props.model.returnReviewTo !== null ?
                                <span>
                                    {this.props.model.returnReviewTo.fullName}<br />
                                    <a href={"mailto: " + this.props.model.returnReviewTo.emailAddress}>{this.props.model.returnReviewTo.emailAddress}</a> <br /> {this.props.model.returnReviewTo.phoneNumber}
                                </span>
                                : "Undefined"}
                        </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Referral Info Contact</Form.Label><br />
                                {this.props.model.referralInfoContact !== undefined && this.props.model.referralInfoContact !== null ?
                                    <span>
                                        {this.props.model.referralInfoContact.fullName}<br />
                                        <a href={"mailto: " + this.props.model.referralInfoContact.emailAddress}>{this.props.model.referralInfoContact.emailAddress}</a> <br /> {this.props.model.referralInfoContact.phoneNumber}
                                    </span>
                                    : "Undefined"}
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label className="font-weight-bold">Coding Clarification Contact</Form.Label><br />
                                {this.props.model.codingClarificationContact !== undefined && this.props.model.codingClarificationContact !== null ?
                                    <span>
                                        {this.props.model.codingClarificationContact.fullName}<br />
                                        <a href={"mailto: " + this.props.model.codingClarificationContact.emailAddress}>{this.props.model.codingClarificationContact.emailAddress}</a> <br /> {this.props.model.codingClarificationContact.phoneNumber}
                                    </span>
                                    : "Undefined"}
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} lg={4}>
                                <Form.Label className="font-weight-bold">Oasis Answer Clarification Contact</Form.Label><br />
                                {this.props.model.oasisAnswerClarificationContact !== undefined && this.props.model.oasisAnswerClarificationContact !== null ?
                                    <span>
                                        {this.props.model.oasisAnswerClarificationContact.fullName}<br />
                                        <a href={"mailto: " + this.props.model.oasisAnswerClarificationContact.emailAddress}>{this.props.model.oasisAnswerClarificationContact.emailAddress}</a> <br /> {this.props.model.oasisAnswerClarificationContact.phoneNumber}
                                    </span>
                                    : "Undefined"}
                        </Form.Group>
                        <Form.Group as={Col} lg={4}>
                            <Form.Label className="font-weight-bold">Waiting on Agency Contact</Form.Label><br />
                            {this.props.model.waitingOnAgencyEscalationContact !== undefined && this.props.model.waitingOnAgencyEscalationContact !== null ?
                                <span>
                                    {this.props.model.waitingOnAgencyEscalationContact.fullName}<br />
                                    <a href={"mailto: " + this.props.model.waitingOnAgencyEscalationContact.emailAddress}>{this.props.model.waitingOnAgencyEscalationContact.emailAddress}</a> <br /> {this.props.model.waitingOnAgencyEscalationContact.phoneNumber}
                                </span>
                                : "Undefined"}
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.props.hideModal}>Close</Button>
                </Modal.Footer>
            </>
        )
    }
}

export default CustomerProfileModal